import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <div class="w-100">
        <div class = 'text-center'>
          Copyright 2018 - Kompas Gramedia
        </div>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js